/**
 * Loads recently viewed products into the recent-product section via Section Rendering API.
 * Hides the section when there are no recently viewed product IDs in localStorage.
 */
import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer, morphSection } from '@theme/section-renderer';

const SECTION_ID_PREFIX = 'shopify-section-';

function initRecentProductSections() {
  if (typeof Theme === 'undefined' || !Theme.routes?.search_url) return;

  const sections = document.querySelectorAll('.recent-product-section[data-section-id]');
  sections.forEach((root) => {
    const sectionId = root.getAttribute('data-section-id');
    if (!sectionId) return;

    const viewedIds = RecentlyViewed.getProductsForDisplay();
    const sectionWrapper = document.getElementById(`${SECTION_ID_PREFIX}${sectionId}`);

    if (!sectionWrapper) return;

    if (viewedIds.length === 0) {
      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        return;
      }
      sectionWrapper.style.display = 'none';
      return;
    }

    const url = new URL(Theme.routes.search_url, location.origin);
    url.searchParams.set('q', viewedIds.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');

    sectionRenderer
      .getSectionHTML(sectionId, false, url)
      .then((sectionHTML) => {
        morphSection(sectionId, sectionHTML);
      })
      .catch(() => {
        sectionWrapper.style.display = 'none';
      });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRecentProductSections);
} else {
  initRecentProductSections();
}
